<template>
  <!-- ここにHTMLを書きます -->
  <div id="explanation">
    <div id="background">
      <h1>ゲームの背景</h1>
      <p>
        あなたは見知らぬ部屋で目を覚ましました.
        ヒビが入ったコンクリートの壁に囲まれ,
        先程まで寝ていた簡易ベッドと洗面所以外には何もありません.
        無機質なその部屋は廃墟の病院のようにも思えました.
        あなたは脱出を試みましたが,
        厚い金属板のドアにはロックがかかっているようです.
        ようやく悪意のある誰かに連れ去られ,
        この部屋に閉じ込められたことに気付いたあなたは外部への連絡を試みましたが,
        普段ポケットに入っているはずのスマートフォンが見つかりません.
        焦りつつも冷静なあなたは部屋の中を探索してみることにしました.
        するとダンボールに詰められたスティック状の携行食とミネラルウォーターが無造作においてあるのが目に付きました.
        どうやらあなたをここに閉じ込めた人物はあなたを餓死させるつもりはないようです.
        そのことに安堵しつつもどうやって脱出しようかと考えていた矢先,
        不気味なアラートが耳に入りました.
        つられて腕を見ると見たことのない不思議なスマートウォッチのようなものが取り付けられ,
        メッセージが表示されていました.
      </p>
    </div>
    <div id="rule">
      <h1>ゲームの説明</h1>
      <h2>
        おめでとうございます！
        <br />あなたはゲームに参加する権利を得ました.
      </h2>
      <p>ゲームにクリアすればこの部屋から脱出することができます.</p>
      <p>
        あなたの他にゲームに参加しているプレイヤーと交渉し,
        ポイントを稼ぐことが目的です.
      </p>
      <p>ゲームクリア時にポイントと引き換えに賞金を手にすることができます.</p>
      <p>
        １ターンは３分間でその間に腕のスマートウォッチで交渉が行なえます.
        ターン中であればいつでも交渉の選択を変えることができます.
      </p>
      <p>１ターンごとに他のプレイヤーとの交渉の組み合わせによりプレイヤーのポイントが増減します.</p>
      <p>
        ポイントをすべて失うと,
        ペナルティにより致死性の毒物がスマートウォッチから注入されゲームから離脱します.
        また, スマートウォッチを外すことはできません.
      </p>
    </div>
    <div id="negotiation">
      <!-- <p>テストプレイは１ターン３分間です.</p>
      <p>テストプレイは１ターン３分間です.</p>-->
      <h2>他のプレイヤーとの交渉</h2>
      <p>あなたは以下の３つの交渉の選択ができます.</p>
      <h2 class="command">沈黙</h2>
      <p>プレイヤー数ｘ１０ｐｔを消費して他のプレイヤーの交渉を見守ります.</p>
      <p>
        協調が成立せず,
        沈黙を選択したプレイヤーが半数以下の場合プレイヤー数ｘ２０ｐｔを獲得します.
      </p>
      <h2 class="command">協調</h2>
      <p>他のプレイヤーと協力し, ゲームクリアを目指します.</p>
      <p>
        半数以上が協調を選択した場合,
        協調を選択したプレイヤー人数ｘ２０ｐｔを獲得します.
      </p>
      <p>ただし, 裏切りが成立した場合はｐｔを獲得することができません.</p>
      <h2 class="command">裏切り</h2>
      <p>協調しているプレイヤーを出し抜くことを試みます.</p>
      <p>
        協調が成立していれば,
        協調を選択したプレイヤー人数ｘ２０ｐｔを獲得します.
      </p>
      <p>裏切りが失敗した場合, 協調を選んだプレイヤー人数ｘ２０ｐｔを失います.</p>
      <!-- <p class="command">密告</p>
    <p>裏切りが発覚する前に, 事前に.</p>
    <p>協調が成立していれば, 協調を選択したプレイヤー人数ｘ２０ｐｔを獲得します.</p>
      <p>裏切りが失敗した場合, 協調を選んだプレイヤーｘ２０ｐｔを失います.</p>-->
    </div>
  </div>
</template>

<script>
export default {};
// ここにJSを書きます
</script>

<style>
@media (max-width: 640px) {
  h2 {
    color: red;
    font-size: 4vw;
  }

  p {
    font-size: 3.5vw;
  }
}

@media (min-width: 640px) {
  h2 {
    color: red;
    font-size: 28px;
  }

  p {
    font-size: 22px;
  }
}

#explanation {
  font-family: "hakidame";
  /* width: 100%; */
  text-align: center;
  /* margin-top: 20px; */
  /* margin-bottom: 20px; */
}

#app {
  background-color: #dcdcdc !important;
  background-image: url("~@/assets/images/background.png");
}
</style>
